import { apiClient } from './client';

export interface StarData {
  index: number;
  x: number;
  y: number;
  size: number;
  brightness: number;
  color: string;
  twinkleSpeed: number;
  twinklePhase: number;
}

export interface ConstellationData {
  name: string;
  starIndices: number[];
}

export interface OccupiedStar {
  starIndex: number;
  planetId: string;
  planetName: string;
  planetStage: number;
}

export interface StarDiscovery {
  starIndex: number;
  starType: string;
  distance: number;
  habitability: number;
  hasPlanet?: boolean;
  linkedPlanetId?: string | null;
  linkedPlanetName?: string | null;
  linkedPlanetStage?: number | null;
  communicationStatus?: string;
  lastContactAt?: string | null;
  properties: Record<string, unknown>;
}

export interface HomeStarProfile {
  starType: string;
  spectralClass: string;
  temperatureK: number;
  color: number;
  colorHex: string;
}

export interface StarMapResponse {
  stars: StarData[];
  constellations: ConstellationData[];
  discoveries: Record<number, StarDiscovery>;
  occupiedStars: OccupiedStar[];
  hasTechnology: boolean;
  hasStarStudy: boolean;
  canScan: boolean;
  scanRequirement: string | null;
  radioActive: boolean;
  scanCoverage: number;
  scannerTier: number;
  detectionConfidence: number;
  reachableRangeLy: number;
  socialUnlocked: boolean;
  spaceExplorationUnlocked: boolean;
  knownRelations: Array<{
    relation_id: string;
    planet_a_id: string;
    planet_b_id: string;
    status: string;
    trust: number;
    tension: number;
    trade: number;
    defence: number;
  }>;
  homeStarIndex: number | null;
  homeStarProfile?: HomeStarProfile;
}

export interface UniversePlanet {
  planet_id: string;
  name: string;
  stage: number;
  home_star_index: number | null;
  radio_active: boolean;
  user?: { name: string };
}

export const starsApi = {
  getMap: () => apiClient.get<{ success: boolean; data: StarMapResponse }>('/stars'),
  getPlanets: () => apiClient.get<{ success: boolean; data: { planets: UniversePlanet[] } }>('/stars/planets'),
  scanStar: (index: number) => apiClient.post<{ success: boolean; data: { discovery: StarDiscovery; scan?: { detectionConfidence: number; scanCoverage: number; scannerTier: number } } }>(`/stars/${index}/scan`),
  sendMessage: (index: number, templateKey: string, customText?: string) =>
    apiClient.post<{ success: boolean; data: { message: { messageId: string; arrivalDay: number; travelDays: number; cost: number } } }>(`/stars/${index}/message`, { template_key: templateKey, custom_text: customText }),
};
